import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { ProcessPage } from './pages/ProcessPage';
import { ShowroomPage } from './pages/ShowroomPage';
import { PricingPage } from './pages/PricingPage';
import { QuotePage } from './pages/QuotePage';
import { FAQPage } from './pages/FAQPage';
import { AboutPage } from './pages/AboutPage';
import { ContactPage } from './pages/ContactPage';
import { TestimonialsPage } from './pages/TestimonialsPage';
import { BookingPage } from './pages/BookingPage';
import { ProductsPage } from './pages/ProductsPage';
import { CartPage } from './pages/CartPage';
import { TermsPage } from './pages/TermsPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { ScrollToTop } from './components/ScrollToTop';
import { CartProvider } from './context/CartContext';
import { Toaster } from 'sonner';
export function App() {
  return <CartProvider data-id="element-0">
      <Toaster position="top-right" expand={false} richColors data-id="element-1" />
      <Router data-id="element-2">
        <ScrollToTop data-id="element-3" />
        <main className="w-full min-h-screen" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<LandingPage data-id="element-7" />} data-id="element-6" />
            <Route path="/process" element={<ProcessPage data-id="element-9" />} data-id="element-8" />
            <Route path="/showroom" element={<ShowroomPage data-id="element-11" />} data-id="element-10" />
            <Route path="/pricing" element={<PricingPage data-id="element-13" />} data-id="element-12" />
            <Route path="/faq" element={<FAQPage data-id="element-15" />} data-id="element-14" />
            <Route path="/about" element={<AboutPage data-id="element-17" />} data-id="element-16" />
            <Route path="/testimonials" element={<TestimonialsPage data-id="element-19" />} data-id="element-18" />
            <Route path="/products" element={<ProductsPage data-id="element-21" />} data-id="element-20" />
            <Route path="/cart" element={<CartPage data-id="element-23" />} data-id="element-22" />
            <Route path="/book" element={<BookingPage data-id="element-25" />} data-id="element-24" />
            <Route path="/contact" element={<ContactPage data-id="element-27" />} data-id="element-26" />
            <Route path="/get-quote" element={<QuotePage data-id="element-29" />} data-id="element-28" />
            <Route path="/terms" element={<TermsPage data-id="element-31" />} data-id="element-30" />
            <Route path="/privacy" element={<PrivacyPage data-id="element-33" />} data-id="element-32" />
          </Routes>
        </main>
      </Router>
    </CartProvider>;
}